import React from 'react';
import { Loader } from '@progress/kendo-react-indicators';

interface FieldLoadingWrapperProps {
  isLoading: boolean;
  children: React.ReactNode;
  actionButtons?: React.ReactNode;
}

const getLoadingClassName = (isLoading: boolean): string => `fieldLoading${isLoading ? ' fieldLoadingActive' : ''}`;

export const FieldLoadingWrapper: React.FC<FieldLoadingWrapperProps> = ({ isLoading, children, actionButtons }) => {
  return (
    <div className={getLoadingClassName(isLoading)}>
      <div className="fieldInput">
        {children}
        {actionButtons}
      </div>
      <div className="fieldSpinnerSlot">
        {isLoading && <Loader className="fieldSpinner" size="small" type="pulsing" />}
      </div>
    </div>
  );
};
